/* eslint-disable no-unused-expressions */

import React, { Component } from "react";
import sysJwt from "../../../utils/sysJwt";
import SysForm from "../../commonComponents/sysForm";
import { post } from "../../../utils/sysAxios";
import { Dialog } from "primereact/dialog";
import { Button } from "primereact/button";
import { confirmAlert } from "react-confirm-alert";
import { apiDataToDropdownList } from "../../../utils/sysHelpers";
import GridTable from "@nadavshaar/react-grid-table";
import { Calendar } from "primereact/calendar";
import { Dropdown } from "primereact/dropdown";
import { toastError } from "../../../utils/sysToast";

class Agent extends Component {
  state = {
    data: {
      agentId: "",
      amount: "",
      diamonds: "",
      billDate: "",
      billNumber: "",
      percentage: "",
      multiplyValue: "",
    },

    contentHeader: "فواتير الوكلاء",
    addButtonLabel: "اضافة فاتورة",
    addButtonIcon: "fa fa-plus",

    dataUrl: "/api/data/GetAgentsBills",
    singleItemUrl: "/api/data/GetAgentBill",
    addUrl: "/api/data/AddAgentBill",
    editUrl: "/api/data/EditAgentBill",
    deleteUrl: "/api/data/DeleteAgentBill",

    diamondsCalculationType: null,
    diamondsCalculationValue: null,

    inEditMode: false,
    inModalMode: false,
    modalHeaderAdd: "اضافة فاتورة وكيل",
    modalSubmitButtonLabelAdd: "اضافة",
    modalSubmitButtonIconAdd: "fa fa-plus",
    modalHeaderEdit: "تعديل فاتورة وكيل",
    modalSubmitButtonLabelEdit: "تعديل",
    modalSubmitButtonIconEdit: "fa fa-edit",
    modalWidth: "50vw",

    editEntityId: 0,

    allAgents: [],
    dates: [new Date(new Date().setDate(new Date().getDate() - 7)), new Date()],
    agentId: null,

    tableData: [],
    tableColumns: [
      {
        id: 1,
        label: "الأوامر",
        field: "SYS_ACTINOS",
        width: "100px",
        maxResizeWidth: "100px",
        resizable: false,
        pinned: true,
        cellRenderer: ({ data }) => {
          return (
            <div id="outer">
              {sysJwt.isAuthorized(["CB20"]) && (
                <div className="inner" title="تعديل">
                  <button
                    className="dropdown-item btn-popup-menu"
                    disabled={this.props.isLoading}
                    onClick={() => {
                      this.getEditFormData(data).then(() => {
                        this.setState({
                          inEditMode: true,
                        });
                        this.showForm();
                      });
                    }}
                  >
                    <i className="fa fa-edit" />
                  </button>
                </div>
              )}
              {sysJwt.isAuthorized(["CB21"]) && (
                <div className="inner" title="حذف">
                  <button
                    className="dropdown-item btn-popup-menu"
                    disabled={this.props.isLoading}
                    onClick={() => this.handleDelete(data)}
                  >
                    <i className="fa fa-trash" />
                  </button>
                </div>
              )}
            </div>
          );
        },
      },
      {
        id: 2,
        label: "ID",
        field: "ID",
        width: "100px",
      },
      {
        id: 3,
        label: "الاسم",
        field: "FULL_NAME",
      },
      {
        id: 4,
        label: "الاسم التجاري",
        field: "TRADE_NAME",
      },
      {
        id: 5,
        label: "المبلغ",
        field: "AMOUNT",
      },
      {
        id: 6,
        label: "النسبة",
        field: "PERCENTAGE",
      },
      {
        id: 7,
        label: "القيمة *",
        field: "MULTIPLY_VALUE",
      },
      {
        id: 8,
        label: "الماسات",
        field: "DIAMONDS",
      },
      {
        id: 9,
        label: "تاريخ الادخال",
        field: "INSERT_DATE",
      },
      {
        id: 10,
        label: "تاريخ الفاتورة",
        field: "BILL_DATE",
      },
      {
        id: 11,
        label: "رقم الفاتورة",
        field: "BILL_NUMBER",
      },
    ],
  };

  componentDidMount() {
    this.getAllAgentsDropdown();
    //this.getDiamondsCalculation();
    this.getData();
  }

  updateForm = (inputId, inputValue) => {
    var data = this.state.data;
    data[inputId] = inputValue;
    this.setState({ data });
  };

  getEditFormData(row) {
    return post(
      this.state.singleItemUrl,
      { id: row.ID },
      this.props.updateIsLoading
    ).then((apiResponse) => {
      var data = this.state.data;

      data["agentId"] = apiResponse.data.respData.data[0].AGENT_ID;
      data["amount"] = apiResponse.data.respData.data[0].AMOUNT;
      data["billDate"] = apiResponse.data.respData.data[0].BILL_DATE;
      data["billNumber"] = apiResponse.data.respData.data[0].BILL_NUMBER;
      data["diamonds"] = apiResponse.data.respData.data[0].DIAMONDS;
      data["percentage"] = apiResponse.data.respData.data[0].PERCENTAGE;
      data["multiplyValue"] = apiResponse.data.respData.data[0].MULTIPLY_VALUE;

      this.setState({
        data: data,
        editEntityId: apiResponse.data.respData.data[0].ID,
      });
    });
  }

  handleDelete(row) {
    confirmAlert({
      title: "حذف الفاتورة",
      message: "هل أنت متأكد من حذف هذه الفاتورة",
      buttons: [
        {
          label: "نعم",
          onClick: () => {
            post(
              this.state.deleteUrl,
              { id: row.ID },
              this.props.updateIsLoading
            ).then((apiResponse) => {
              apiResponse.data.respCode === 0 ? this.getData() : null;
            });
          },
        },
        {
          label: "الغاء",
          onClick: () => null,
        },
      ],
    });
  }

  showForm() {
    this.setState({ inModalMode: true });
  }

  closeModal() {
    var data = this.state.data;

    Object.keys(data).forEach(function (key) {
      Array.isArray(data[key]) ? (data[key] = []) : (data[key] = null);
    });

    this.setState({
      inModalMode: false,
      inEditMode: false,
      data: data,
      editEntityId: 0,
    });

    this.getData();
  }

  getData() {
    if (!this.state.dates[0] || !this.state.dates[1]) {
      toastError("يرجى اختيار التاريخ");
    } else {
      post(
        this.state.dataUrl,
        {
          dateFrom: this.state.dates[0],
          dateTo: this.state.dates[1],
          agentId: this.state.agentId,
        },
        this.props.updateIsLoading
      ).then((apiResponse) => {
        this.setState({ tableData: apiResponse.data.respData.data });
      });
    }
  }

  getAllAgentsDropdown() {
    post("/api/data/GetAllAgents", null, this.props.updateIsLoading).then(
      (apiResponse) => {
        this.setState({
          allAgents: apiResponse.data.respData.data,
        });
      }
    );
  }

  getDiamondsCalculation() {
    post(
      "/api/data/GetDiamondsCalculation",
      null,
      this.props.updateIsLoading
    ).then((apiResponse) => {
      this.setState({
        diamondsCalculationType:
          apiResponse.data.respData.diamondsCalculationType,
        diamondsCalculationValue:
          apiResponse.data.respData.diamondsCalculationValue,
      });
    });
  }

  handleAmountKeyPress(e) {
    if (e.charCode === 13) {
      var data = this.state.data;

      if (this.state.diamondsCalculationType === "P") {
        data["diamonds"] =
          (this.state.data.amount * this.state.diamondsCalculationValue) / 100;
      } else if (this.state.diamondsCalculationType === "D") {
        data["diamonds"] =
          this.state.data.amount * this.state.diamondsCalculationValue;
      }
      this.setState({
        data: data,
      });
    }
  }

  calculateDimonds(e) {
    if (e.charCode === 13) {
      if (
        this.state.data.amount &&
        this.state.data.percentage &&
        this.state.data.multiplyValue
      ) {
        var data = this.state.data;
        data["diamonds"] =
          ((this.state.data.amount * this.state.data.percentage) / 100) *
          this.state.data.multiplyValue;
        this.setState({
          data: data,
        });
      }
    }
  }

  doSubmit() {
    const submitData = Object.assign({}, this.state.data);

    if (this.state.inEditMode) {
      submitData["id"] = this.state.editEntityId;
    }

    post(
      this.state.inEditMode ? this.state.editUrl : this.state.addUrl,
      submitData,
      this.props.updateIsLoading
    ).then((apiResponse) => {
      if (apiResponse.data.respCode === 0) {
        this.props.updateIsLoading(false);
        this.closeModal();
      }
    });
  }

  render() {
    return (
      <div className="sys-content-component fade-in">
        <div className="row">
          <div className="col">
            <h4>{this.state.contentHeader}</h4>
          </div>
          <div className="col-10 flex-container-left">
            التاريخ:
            <Calendar
              selectionMode="range"
              showIcon="true"
              value={this.state.dates}
              className="flex-item-left mr-2"
              onChange={(e) => this.setState({ dates: e.value })}
              style={{ width: "250px" }}
            />
            &nbsp; الوكيل:
            <Dropdown
              value={this.state.agentId}
              showClear={true}
              options={this.state.allAgents}
              filter={true}
              onChange={(e) => this.setState({ agentId: e.target.value })}
            />
            &nbsp;
            <Button
              label="بحث"
              className="p-button-secondary"
              disabled={this.props.isLoading}
              onClick={() => {
                this.getData();
              }}
            />
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
            {sysJwt.isAuthorized(["CB15"]) && (
              <Button
                label={this.state.addButtonLabel}
                icon={this.state.addButtonIcon}
                className="p-button-secondary"
                disabled={this.props.isLoading}
                onClick={() => {
                  this.setState({ inEditMode: false });
                  this.showForm();
                }}
              />
            )}
          </div>
        </div>
        <hr />
        <Dialog
          visible={this.state.inModalMode}
          style={{ width: this.state.modalWidth }}
          headerStyle={{ "background-color": "#F0F0F0", color: "black" }}
          onHide={(e) => this.closeModal()}
          dismissableMask={true}
          closable={false}
          header={
            <h5 className="modal-header">
              {this.state.inEditMode
                ? this.state.modalHeaderEdit
                : this.state.modalHeaderAdd}
            </h5>
          }
          footer={
            <div>
              <Button
                label={
                  this.state.inEditMode
                    ? this.state.modalSubmitButtonLabelEdit
                    : this.state.modalSubmitButtonLabelAdd
                }
                icon={
                  this.state.inEditMode
                    ? this.state.modalSubmitButtonIconEdit
                    : this.state.modalSubmitButtonIconAdd
                }
                className="p-button-secondary"
                disabled={this.props.isLoading}
                onClick={() => this.doSubmit()}
              />
              <Button
                label="الغاء"
                icon="fa fa-close"
                className="p-button-danger"
                onClick={() => this.closeModal()}
              />
            </div>
          }
        >
          <SysForm
            isLoading={this.props.isLoading}
            inEditMode={this.state.inEditMode}
            data={this.state.data}
            updateForm={this.updateForm}
            inputs={[
              {
                type: "dropdown",
                id: "agentId",
                label: "الوكيل",
                options: this.state.allAgents,
                disabled: this.state.inEditMode ? true : false,
              },
              {
                type: "text",
                id: "amount",
                label: "المبلغ",
                disabled: false,
                keyPressHandler: (e) => this.calculateDimonds(e),
                tooltip: "اكتب المبلغ بعدها اضغط على Enter لأحتساب الماسات",
              },
              {
                type: "text",
                id: "percentage",
                label: "النسبة",
                disabled: false,
                keyPressHandler: (e) => this.calculateDimonds(e),
                tooltip: "اكتب النسبة بعدها اضغط على Enter لأحتساب الماسات",
              },
              {
                type: "text",
                id: "multiplyValue",
                label: "القيمة *",
                disabled: false,
                keyPressHandler: (e) => this.calculateDimonds(e),
                tooltip:
                  "اكتب القيمة التى تضرب بها بعدها اضغط على Enter لأحتساب الماسات",
              },
              {
                type: "text",
                id: "diamonds",
                label: "عدد الماسات",
                disabled: true,
              },
              {
                type: "defaultdate",
                id: "billDate",
                label: "تاريخ الفاتورة",
                disabled: false,
              },
              {
                type: "text",
                id: "billNumber",
                label: "رقم الفاتورة",
                disabled: false,
              },
            ]}
          />
        </Dialog>
        <GridTable
          columns={this.state.tableColumns}
          rows={this.state.tableData}
          pageSizes={[10, 15, 20, 30, 40]}
          showColumnVisibilityManager={false}
          texts={{
            search: "بحث:",
            totalRows: "إجمالي عدد البيانات:",
            rows: "الصف:",
            selected: "المحدد",
            rowsPerPage: "عدد الصفوف في الصفحة:",
            page: "الصفحة:",
            of: "من",
            prev: "السابق",
            next: "التالي",
            columnVisibility: "اظهار الاعمدة",
          }}
        />
      </div>
    );
  }
}

export default Agent;
